export default __webpack_public_path__ + "static/media/edge-brandsC.11b95cac.png";